import * as R from 'ramda'
import CryptoJS from 'crypto-js'
const { v4: uuidv4 } = require('uuid')
import valicator from 'validator'
import { navigate } from 'gatsby'
import Cookies from 'js-cookie'
import fileDialog from 'file-dialog'
import i18next from '../static/lang/i18n'
import { lang, serverUrl, serverPrefixUrl } from '../config'
import axios from 'axios'
import codeData from './codeData'
import moment from 'moment'
import G from '../util/globalFunction'
import TF from '../util/tremFunction'

let __popupFunction__ = msg => console.log(msg)

export const registerPopupFunction = (fnt) => {
    __popupFunction__ = fnt
}

/**
 * 브라우저 alert 대체
 *
 * @param {string} message 메시지내용
 * @param {string} title 타이틀 null 경우 알림
 * @reurns Promise void
 */
const alert = (message, title, returnFunction) => {
    title = title || G.t('trem.lang.home.1137') /* 알림 */
    const popupType = 'alert'

    const ret =  __popupFunction__
        ? __popupFunction__({ popupType, title, message, returnFunction })
        : alert(`[${title}] ${message}`)

    // 팝업 기능이 안되서 alert인 경우는 바로 callback 호출
    if (!__popupFunction__) {
        returnFunction()
    }

    return ret
}

/**
 * 브라우저 confirm 대체
 *
 * @param {string} message 메시지 내용
 * @param {string} title 타이틀이 null일경우 확인
 * @returns Promise (boolean)
 */
const confirm = (message, title) => {
    title = title || G.t('trem.lang.home.0287') /* 확인 */
    const popupType = 'confirm'
    // return __popupFunction__
    //     ? __popupFunction__({ popupType, title, message })
    //     : confirm(`[${title}] ${message}`)
    if (__popupFunction__) {
        return __popupFunction__({ popupType, title, message })
    } else {
        return new Promise((resolve, reject) => {
            const result = window.confirm(`[${title}] ${message}`)
            if (result) {
                resolve(true)
            } else {
                resolve(false)
            }
            if (target) {
                target.focus()
            }
        })
    }
}

/**
 * 오류 메시지를 출력한다.
 * 오류메시지는 문자열 array로 구현한다.
 *
 * @param {[string]} errors  오류메시지 목록
 */
const alertErrors = errors => {
    const title = '오류'
    const popupType = 'alert'
    const message = errors
    return __popupFunction__({ popupType, title, message })
}

let __loading_start = null
let __loading_end = null
let __loading_force_end = null

/**
 * 프로그래스바 진행 기능 설정 화명
 *
 * @param {function} start 프로그래스바 시작
 * @param {function} end 프로그래스바 종료
 * @param {function} force_end 프로그래스바 강제 종료
 */
export const registerLoadingBarFunction = (start, end, force_end) => {
    __loading_start = start
    __loading_end = end
    __loading_force_end = force_end
}

/**
 * 프로그래스바 시작
 * 시작은 중첩될 수 있음
 */
const loadingStart = () => __loading_start && __loading_start()

/**
 * 프로그래스바 종료
 * 중첩되어 있는 loadingStart가 있으면 값만 차감
 */
const loadingEnd = () => __loading_end && __loading_end()

/**
 * 중첩되있어서도 프로그래스바 종료
 */
const loadingForceEnd = () => __loading_force_end && __loading_force_end()

/**
 * 주어진 argment를 기반으로 함수를 실행한 후 결과를 name의 property로 추가하여 리턴하는 함수
 * @param {function} fnt 실행할 함수
 * @param {string} name 추가할 property 값
 * @param {input} fnt에 주입될 argment
 * @return object 함수 실행 결과 값이 추가된 input 복사본
 */
const appendProp = R.curryN(3, (fnt, name, input) => {
    const output = R.clone(input)
    output[name] = fnt(input)
    return output
})

/**
 * 입력 파라미터가 function인지 확인
 *
 * @param {function} function 체크하기 위한 객체
 * @return {Boolean}  function 여부
 */
const isFunction = fnt => fnt && {}.toString.call(fnt) === '[object Function]'

/**
 * URL인지 확인
 * @param {string} str 문자열
 */
export const validURL = str => {
    var pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$',
        'i'
    ) // fragment locator
    return !!pattern.test(str)
}

/**
 * base64Encoding
 * @param {string} str 문자열
 */
export const base64EncodeUrl = str => str.replace(/\+/g, '-').replace(/\//g, '_').replace(/\+$/, '')

/**
 * base64Decoding
 * @param {string} str base64 문자열
 */
export const base64DecodeUrl = str => {
    str = (str + '===').slice(0, str.length + (str.length % 4))
    str = str.replace(/-/g, '+').replace(/_/g, '/')
    return str.replace(/=/g, '')
}

/**
 * url 파싱
 * @param {string} queryString
 */
export const queryParm = queryString => {
    const reducser = (acc, value) => {
        const pair = value.split('=')
        acc[pair[0]] = pair[1]
        return acc
    }
    return queryString.substring(1).split('&').reduce(reducser, {})
}

/**
 * 주어진 시간(초)를 기다린다.
 * async await 를 사용하여야 한다.
 * @param {number} seconds delay 시간
 */
const delay = seconds =>
    new Promise(resoler => {
        setTimeout(() => {
            resoler(true)
        }, seconds * 1000)
    })

/**
 * 라인피드를 <br />로 변환
 * @param {string} str
 */
const newLineToBR = str => str.split('\n').join('<br />')

/**
 * 주어진 url을 주어진 시간동안 image를 리턴하는 url인지 확인함
 * 시간이 초과 되면 초과 오류 발생
 *
 * @param {string} url 이미지를 리턴하는 url
 * @param {integer} seconds 확인 지연 시간
 */
const isImageUrlWithTimeout = (url, seconds) => {
    let ended = false
    const isImageUrl = () =>
        new Promise((resolve, reject) => {
            const img = new Image()
            img.onerror = img.onabort = () => {
                if (ended === false) {
                    ended = true
                    reject(url)
                }
            }
            img.onload = () => {
                if (ended === false) {
                    ended = true
                    resolve(url)
                }
            }
            img.src = url
        })
    const timeDelay = () =>
        delay(seconds).then(() => {
            if (ended === false) {
                ended = true
                throw new Error(`응답시간 초과 : ${seconds}초 이내 응답 필요`)
            }
        })
    return valicator.isURL(url)
        ? Promise.race([isImageUrl(), timeDelay()])
        : Promise.reject(new Error('URL 형식이 아닙니다.'))
}

/**
 * 0~max 사이의 랜덤 integer 숫자 리턴
 * @param {integer} max
 */
const randomInt = (max = 10) => Math.floor(Math.random() * max)

/**
 * Array로 구성된 name,value 목록을 관리하는 객체를 리턴한다.
 * @param {integer} array [{name,value}, {name,value}] 형태의 객체
 */
const NameValueArray = array => {
    const getValue = name =>
        R.pipe(
            () => array.find(obj => obj.name === name),
            R.ifElse(
                R.identity,
                p => p.value,
                () => ''
            )
        )()
    const setValue = (name, value) => {
        const replace = () => {
            const newArray = []
            for (const obj of array) {
                obj.name !== name ? newArray.push(obj) : newArray.push({ name, value })
            }
            return newArray
        }
        const insert = () => {
            array.push({ name, value })
            return array
        }
        return array && array.find(obj => obj.name === name) ? replace() : insert()
    }
    return {
        getValue,
        setValue,
    }
}

const numberComma = val => (val ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0')

/**
 * 0에서 부터 주어진 값 -1까지 리턴
 * @param {integer} x 종료 미만 값
 */
const rangeTo = end => ({
    end,
    *[Symbol.iterator]() {
        for (let i = 0; i < end; i++) {
            yield i
        }
    },
})

/**
 * 0에서 부터 주어진 end값 -1까지 리턴
 * @param {integer} start 시작 값
 * @param {integer} end 종료 미만값
 */
const rangeFromTo = (start, end) => ({
    end,
    *[Symbol.iterator]() {
        for (let i = start; i < end; i++) {
            yield i
        }
    },
})

/**
 * 디버그를 위해 객체를 alert로 보여줌
 * @param {*} obj 보여줄 정보
 * @returns
 */
const alertObject = obj => alert(JSON.stringify(obj))

/** 작업하지 않는 함수 */
const passFn = () => {}

/** 세션별로 seed를 생성하여 보관한다. */
const getSeed = R.pipe(
    () => window.sessionStorage.getItem('__seed__'),
    R.unless(R.identity, () => uuidv4().substr(0, 32)),
    R.tap(seed => window.sessionStorage.setItem('__seed__', seed))
)

/*JSON object를 암호화된 txt로 변경 */
const encryptObj = R.pipe(JSON.stringify, txt => CryptoJS.AES.encrypt(txt, getSeed()).toString())

/*암호화된 txt를 json으로 변경*/
const decryptToObj = ciphertext =>
    R.pipe(
        () => CryptoJS.AES.decrypt(ciphertext, getSeed()),
        bytes => bytes.toString(CryptoJS.enc.Utf8),
        JSON.parse
    )()

/** tailwindcss media query */
const getMediaSize = () => {
    if (typeof window === `undefined`) {
        return 'sm'
    } else {
        const match = w => !window.matchMedia(`(min-width:${w}px)`).matches
        return match(640)
            ? 'sm'
            : match(768)
            ? 'md'
            : match(1024)
            ? 'lg'
            : match(1280)
            ? 'xl'
            : '2xl'
    }
}

const setLang = R.pipe(
    () => Cookies.get('__floor_lang__'),
    R.unless(R.identity, () => {
        Cookies.set('__floor_lang__', lang)
        return lang
    }),
    l => i18next.changeLanguage(l)
)

/**다국어 처리 */
const t = R.pipe(
    R.tap(() => setLang()),
    i18next.t.bind(i18next)
)

/**
 * 현재 화면 Layout이 public인지 확인
 * 화면의 갱신을 원하면 반드시 globalContext의 setPublicLayout을 사용
 * @returns boolean
 */

/**
 * 페이지로 이동 페이지가 없을 경우 신규 생성
 * @param {string} url 이동할 페이지
 * @param {*} params 파라미터
 */
const gotoPage = (url, params) => {
    const state = { ...params, prevPath: url }
    TF.setAccessPageHistory(url)
    window.location.pathname === url
        ? navigate('/redirectPrev', { state })
        : navigate(url, { state })
}

/**
 * 무조건 페이지 오픈
 * @param {*} url 오픈할 url
 * @param {*} params 파라미터
 */
const openPage = (url, params) => {
    const state = { ...params, prevPath: url, pageMode: 'new' }
    TF.setAccessPageHistory(url)
    window.location.pathname === url
        ? navigate('/redirectPrev', { state })
        : navigate(url, { state })
}

const gotoLoginPage = () => {
    TF.setAccessPageHistory('/login')    
    navigate('/login', { state: { previousPage: window.location.pathname } })
}

const gotoHomePage = () => {
    TF.setAccessPageHistory('/home')
    navigate('/home', { state: { previousPage: window.location.pathname } })
}

const loadImage = () =>
    new Promise((resolve, reject) => {
        try {
            fileDialog({ multiple: false, accept: 'image/*' }).then(files => {
                var reader = new FileReader()
                reader.onload = function () {
                    var image = new Image()
                    image.src = reader.result
                    image.onload = function () {
                        resolve({ image, dataURL: reader.result })
                    }
                }
                reader.readAsDataURL(files[0])
            })
        } catch (err) {
            reject(err)
        }
    })

/**
 * graphql parameter empty, null, undefined 처리
 * (파라미터 값이 있을때만 쿼리 정상실행됨)
 */
const removeEmptyUndefinedOrNull = obj => {
    Object.keys(obj).forEach(k => {
        ;(obj[k] && typeof obj[k] === 'object' && removeEmptyUndefinedOrNull(obj[k])) ||
            (!obj[k] && obj[k] !== undefined && delete obj[k]) ||
            (typeof obj[k] === 'undefined' && delete obj[k])
    })

    return !R.isNil(obj) && !(Object.keys(obj).length === 0) ? obj : null
}

/**
 * graphql jsonArray parameter 처리
 */
const makeJsonArrayForGraphql = param => {
    let jsonArray = []
    const arrayLength = param.length

    param.map(obj => {
        let strJson = '{'
        Object.keys(obj).map((key, index2) => {
            const value = typeof obj[key] === 'string' ? '"' + obj[key] + '"' : obj[key]
            strJson += `${key}:${value}`
            strJson += Object.keys(obj).length - 1 !== index2 ? ',' : ''
        })
        strJson += '}'
        jsonArray.push(strJson)
    })

    return jsonArray
}

/**
 * 엑셀 다운로드
 * (API 서버 엑셀 다운로드 기능)
 * url : API 서버 엑셀 다운 url
 * fileName : 엑셀 파일 이름 (확장자 제외)
 */
const downloadExcel = (url, params, fileName) => {
    axios({
        method: 'GET',
        url: `${serverUrl}${serverPrefixUrl}${url}`,
        params: params,
        responseType: 'blob',
    }).then(response => {
        const url = window.URL.createObjectURL(
            new Blob([response.data], { type: response.headers['content-type'] })
        )
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${fileName}.xlsx`)
        document.body.appendChild(link)
        link.click()
    })
}

const codeArrayByName = R.pipe(
    name => codeData.find(({ NAME }) => NAME === name),
    R.ifElse(
        R.identity,
        ({ codeList }) => codeList.map(({ CODE: key, NAME: title }) => ({ key, title })),
        () => []
    )
)

const codeArrayByNameWithTotal = R.pipe(codeArrayByName, array => {
    array.unshift({ title: '미선택', key: '' })
    return array
})

const dateFormat = (value, type) => moment(value).format(type || 'YYYY-MM-DD')

const checkNulltoObject = ( source, target ) => {

    const currentLang = Cookies.get('__floor_lang__') || 'ko'
    let returnValue = null;

    if( currentLang === "ko" ){
        returnValue = source
    }else{

        if(R.isNil(target)){
            returnValue = source
        }else{
            returnValue = target
        }
    }
    
    return returnValue
}

const radioHandleClick = (e) => {
    const currentAriaChecked = (e.currentTarget.getAttribute("aria-checked") === 'true');
    e.currentTarget.setAttribute("aria-checked", !currentAriaChecked)
}

export default {
    alert,
    confirm,
    alertErrors,
    loadingStart,
    loadingEnd,
    loadingForceEnd,
    isFunction,
    appendProp,
    validURL,
    base64EncodeUrl,
    base64DecodeUrl,
    queryParm,
    delay,
    newLineToBR,
    isImageUrlWithTimeout,
    randomInt,
    NameValueArray,
    numberComma,
    dateFormat,
    rangeTo,
    rangeFromTo,
    alertObject,
    passFn,
    encryptObj,
    decryptToObj,
    getMediaSize,
    t,
    gotoPage,
    openPage,
    gotoLoginPage,
    gotoHomePage,
    loadImage,
    removeEmptyUndefinedOrNull,
    makeJsonArrayForGraphql,
    downloadExcel,
    codeArrayByName,
    codeArrayByNameWithTotal,
    checkNulltoObject,
    radioHandleClick
}
